import Image from "next/image";
import { cn } from "@/lib/utils";

export const Logo = ({ className }: { className?: string }) => {
  return (
    <Image
      src="/weekrt-logo-final1.png"
      alt="Weekrt Logo"
      width={50}
      height={50}
      className={cn("w-10 h-10 md:w-14 md:h-14", className)}
      priority
    />
  );
};
